import { Menu, Transition } from "@headlessui/react";
import { BookmarkIcon, FlagIcon } from "@heroicons/react/outline";
import { CogIcon } from "@heroicons/react/solid";
import React, { Fragment, useContext } from "react";
import { PopupContext } from "../containers/Popup";

export const SettingsActions = () => {
  const { showModal, setShowModal } = useContext(PopupContext);

  const actions = [
    {
      title: "My Profile",
      textColor: "white",
      icon: <FlagIcon className="w-5 h-5 text-white-400" />,
      onClick: () =>
        showModal.name === "account"
          ? setShowModal({ name: null, detail: null })
          : setShowModal({ name: "account", detail: null }),
    },
    {
      title: "My Bookmarks",
      textColor: "white",
      icon: <BookmarkIcon className="w-5 h-5 text-white-400" />,
      onClick: (e) => setShowModal({ name: "bookmarks", detail: null }),
    },
  ];

  return (
    <Menu>
      <span className="tooltip" title="Settings">
        <Menu.Button className="mr-3 bg-gray-100 bg-opacity-10 hover:bg-opacity-30 w-9 h-9 rounded-full">
          <CogIcon className="w-5 h-5 text-white mx-auto" />
        </Menu.Button>
      </span>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute menu z-50 w-40 mt-2 right-10 origin-top-right bg-gray-600 divide-y divide-gray-100 border border-gray-500 rounded-md shadow-xl ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="px-1 py-1 ">
            {actions.map((action) => {
              return (
                <Menu.Item key={action.title}>
                  {({ active }) => (
                    <button
                      type="button"
                      className={`hover:bg-blue-400 text-${action.textColor} group flex rounded-md items-center w-full px-2 py-2 text-sm `}
                      onClick={action.onClick}
                    >
                      {action.icon}
                      <span className="ml-2">{action.title}</span>
                    </button>
                  )}
                </Menu.Item>
              );
            })}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};
